module.exports = __webpack_public_path__ + "img/home_hover_story_card1.d618e68f.svg";